import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';

export const addDenyUserList = createAction(
  `${reduxKey}.DAMZ_DENY_USER_LIST_ADD`,
  (username: string) => ({ username })
);
